<template>
  <common
    :searchFrom="searchFrom"
    :tableTitle="tableTitle"
    :list="list"
    @crudClick="crudClick"
    :total="total"
    :arrPageSize="arrPageSize"
    :pageSize="searchFrom.pageSize"
    :BoolModal="isshowModal"
    :title="titleModal"
    @changeBindModal="changeBindModal"
    @closedeleteModal="closedeleteModal"
    :unChange="unChange"
    :footerHide="footerHide"
    :width="width"
    :loading="loading"
    :maskClosable="maskClosable"
    :current.sync="current"
    @pageClick="getList"
    ref="common"
  >
    <template slot="add">
      <FormItem>
        <Button type="primary" @click="crudClick(0, 'add')" icon="md-add">
          {{ $t("add") }}
        </Button>
      </FormItem>
    </template>

    <div slot="content">
      <template v-if="crudText == 'delete'">
        <p>{{ $t("titleModal") }}</p>
      </template>
      <template v-else>
        <Form
          label-position="right"
          :model="dataDetails"
          :label-width="130"
          :rules="ruleFrom"
          ref="dataDetails"
        >
          <FormItem :label="$t('agentName')" prop="agent_id">
            <Select
              v-model="dataDetails.agent_id"
              filterable
              :disabled="disabled"
              placeholder="Please Select Agent"
            >
              <Option
                v-for="item in objAgent"
                :value="item.id"
                :key="item.id"
                >{{ item.agent_name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem :label="$t('prefix')" prop="prefix">
            <i-Input
              :disabled="disabled"
              v-model="dataDetails.prefix"
              placeholder="Please Enter Prefix"
            ></i-Input>
          </FormItem>
          <FormItem :label="$t('packageTitle')" prop="title">
            <i-Input
              :disabled="disabled"
              v-model="dataDetails.title"
              placeholder="Please Enter Title"
            ></i-Input>
          </FormItem>
        </Form>
      </template>
    </div>
  </common>
</template>

<script>
import { add, getPackage, getDetails, update, del } from "@/api/system/package";
import common from "_c/common-body";
import basic from "@/utils/basic";
import nodata from "@/utils/nodata";
import boxMes from "@/utils/message";

export default {
  name: "timezone",
  components: {
    common,
  },
  data() {
    return {
      current: 1,
      arrPageSize: [15, 30, 50, 100],
      maskClosable: false,
      loading: true,
      width: 600,
      list: [],
      searchFrom: {
        page: 1,
        pageSize: 15,
        keywords: "",
      },
      // Warehouse总数据
      total: 0,
      // 详情模态框显示/隐藏
      isshowModal: false,
      // 数据详情
      dataDetails: {},
      // 删除模态显示/隐藏
      Delmodal1: false,
      // 模态框标题
      isshowModalTitle: "",
      disabled: false,
      ruleFrom: {
        agent_id: [
          {
            required: true,
            type: "number",
            message: "agent cannot be empty",
            trigger: "change",
          },
        ],
        prefix: [
          {
            required: true,
            message: "prefix cannot be empty",
            trigger: "blur",
          },
          {
            max: 25,
            message: "Please enter maximum 25",
            trigger: "blur",
          },
        ],
        title: [
          {
            required: true,
            message: "title cannot be empty",
            trigger: "blur",
          },
          {
            max: 25,
            message: "Please enter maximum 25",
            trigger: "blur",
          },
        ],
      },
      footerHide: false,
      crudText: "",
      titleModal: "",
      deleteModal: false,
      delId: 0,
      preForm: {},
      unChange: true,
      objAgent: {},
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("agentName"),
        key: "agent_name",
        align: "center",
      });
      columns.push({
        title: this.$t("prefix"),
        key: "prefix",
        align: "center",
      });
      columns.push({
        title: this.$t("packageTitle"),
        key: "title",
        align: "center",
      });
      columns.push({
        title: this.$t("operation"),
        slot: "operation",
        align: "center",
        minWidth: 150,
      });
      return columns;
    },
  },
  watch: {
    dataDetails: {
      handler: function (nowVal) {
        var $this = this;
        for (let i in $this.dataDetails) {
          if (nowVal[i] !== $this.preForm[i]) {
            $this.unChange = false;
            break;
          } else {
            $this.unChange = true;
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    changeBindModal(val) {
      if (!val) {
        this.isshowModal = false;
      } else {
        if (this.crudText === "delete") {
          console.log(this.delId);
          this.deleteList(this.delId);
        } else {
          this.confirm("dataDetails");
        }
      }
    },
    closedeleteModal(e) {
      if (e === false) {
        this.isshowModal = false;
        if (this.crudText != "delete") {
          this.$refs["dataDetails"].resetFields();
        }
      }
    },
    confirm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.crudText === "add") {
            this.addList();
          } else {
            this.updateList();
          }
        } else {
          console.log(this.$t("fail"));
        }
      });
    },
    crudClick(item, text) {
      this.objAgent = basic.objAgent();
      this.titleModal = this.$t(text);
      this.maskClosable = false;
      this.width = 600;
      this.footerHide = false;
      this.unChange = true;
      this.disabled = false;
      this.dataDetails = {};
      this.preForm = {};
      if (item !== 0) {
        if (text == "delete") {
          this.width = 300;
          this.delId = item.id;
          this.unChange = false;
          this.maskClosable = true;
        } else {
          if (text === "show") {
            this.disabled = true;
            this.footerHide = true;
            this.maskClosable = true;
          }
          this.dataDetails = {};
          this.preForm = {};
          this.getDetailsList(item.id, text);
        }
      }
      this.isshowModal = true;
      this.crudText = text;
    },
    getDetailsList(id) {
      getDetails(id)
        .then((res) => {
          delete res.data.payload.country;
          this.dataDetails = res.data.payload;
          this.preForm = JSON.parse(JSON.stringify(res.data.payload));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getList() {
      this.loading = true;
      getPackage(this.searchFrom)
        .then((res) => {if (!res.data.status) {
            this.loading = false;
            boxMes.alertMes(res, this);
            return;
          }
          this.total = res.data.payload.total;
          this.list = res.data.payload.rows.map((item) => {
            let agent = nodata.noData(basic.objAgent(), item.agent_id, "agent");
            item.agent_name = agent.name;
            return item;
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addList() {
      add(this.dataDetails).then((res) => {
        boxMes.alertMes(res, this);
      });
    },
    updateList() {
      update(this.dataDetails).then((res) => {
        boxMes.alertMes(res, this);
      });
    },
    deleteList(id) {
      del(id).then((res) => {
        boxMes.alertMes(res, this);
      });
    },
  },
};
</script>

<style scoped lang="less">
.delBtn {
  margin: 0 10px;
}
.ivu-page {
  margin-top: 20px;
}
.footer-modal {
  width: 100%;
  text-align: center;
}
</style>
